import { DefaultOptionType } from "@opendash/core";
import { Select } from "antd";
import { observer } from "mobx-react-lite";
import React from "react";
import { useKanbanStates } from "../hooks/useKanbanStates";

export const KanbanStateSelect = observer(
  (props: {
    value?: string | number;
    onChange?: (value: string | number) => void;
    width?: string;
    disabled?: boolean;
    placeholder?: string;
    disabledValues?: string[];
    allowClear?: boolean;
  }) => {
    const [kanbanStateSelectData, setKanbanStateSelectData] = React.useState<
      DefaultOptionType[]
    >([]);
    const { states, loading } = useKanbanStates();

    React.useEffect(() => {
      const selectData: DefaultOptionType[] = states.map((state) => {
        return {
          label: state.label,
          title: state.description,
          value: state.id,
          disabled: props.disabledValues?.includes(state.id),
        };
      });

      setKanbanStateSelectData(selectData);
    }, [states]);

    return (
      <Select
        allowClear={props.allowClear}
        onChange={props.onChange}
        options={kanbanStateSelectData}
        value={props.value}
        style={{ display: "block", width: props.width ?? "100%" }}
        loading={loading}
        disabled={props.disabled}
        placeholder={props.placeholder}
        onClear={() => props.onChange?.(undefined)}
      />
    );
  }
);
